import React from "react";
import {FormattedMessage} from "react-intl";
import EditAddress from "../../EditAddress/EditAddress";

const AddressInfo = (props) => {

    let title = props.type === "shipping" ?
        {id: "app.order.confirm.shipping.address", default: "ShippingTopics Address"}
        :
        {id: "app.order.confirm.billing.address", default: "Billing Address"};


    return (
        <div>
            <div className="row add-info-div">

                <div className="col-md-8 custom-col-8 add-info-mobile-view-hide">
                    <span className="sub-title sub-title-responsive">
                        <b><FormattedMessage id={title.id}
                                          defaultMessage={title.default}
                                          description=""/></b>
                    </span>
                </div>
                <div className="col-md-4 custom-col-12 edit-address-responsive edit-address-responsive-mobile ">
                    <EditAddress userId={props.userId}
                                 shippingAddressId={props.userDetails.shippingAddressId}
                                 userAddresses={props.userAddresses}
                                 getUserAddresses={props.getUserDetails}
                                 onAddressSelect={props.onAddressSelect}
                                 userInfo={props.userDetails}
                                 getUserDetails = {props.getUserDetails}
                                 type={props.type}/>

                </div>
            </div>
            {/*<div className="row">
                <div className="col-md-12">
                    <div className="dotted-line"></div>
                </div>
            </div>*/}
            <div className="row">
                <div className="col-md-7">{props.address.lastName + " " + props.address.firstName}</div>
                <div className="col-md-5 resp-cell-no">
                    <span className="pull-right">{props.address.cellOrMobileNumber}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div>&#12306;{props.address.postalCode}</div>
                </div>
            </div>
                <div className="row">
                <div className="col-md-12">
                    <div>{props.address.province}</div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div>{props.address.city}</div>
                </div>
            </div>
                <div className="row">
                <div className="col-md-12">
                    <div>{props.address.streetAddress}</div>
                </div>
            </div>
                <div className="row">
                <div className="col-md-12">
                    <div>{props.address.addressLine2}</div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                       {/* {props.address.country === "jp" ?
                            <FormattedMessage id="app.address.country-japan"
                                              defaultMessage="Japan"
                                              description=""/> : <div>{props.addressDetails.country}</div>
                        }*/}

                </div>
            </div>
        </div>
    )
};

export default AddressInfo;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderConfirmation/AddressInfo/AddressInfo.js